<!-- src/components/AboutComponent.vue -->
<template>
  <div class="about">
    <h1>소개 페이지</h1>
    <p>우리에 대해 더 알아보세요.</p>
  </div>
</template>

<!-- 주소 파라미터는 $route.params.id 으로 .id <- 고유값을 비교해야함 route에서 :id 인지 확인 는 -->
<script>
export default {
  name: "AboutPage",
};
</script>

<style scoped>
.about {
  text-align: center;
  padding: 20px;
}
</style>
